import type { FC } from "react";

import type { UseFormReturn } from "react-hook-form";

import type { INVESTMENT_EXPERIENCE_VALUES } from "../../constant";
import { RadiosInput } from "../../RadiosInput";
import type { InvestmentExperience } from "./schema";

export const INVESTMENT_EXPERIENCE_OPTIONS: {
  label: string;
  value: (typeof INVESTMENT_EXPERIENCE_VALUES)[number];
}[] = [
  { label: "0 years", value: "none" },
  { label: "1 - 5 years", value: "1_to_5_years" },
  { label: "Over 5 years", value: "over_5_years" },
];

type YearsExperienceInputsProps = {
  form: UseFormReturn<InvestmentExperience>;
};

export const YearsExperienceInputs: FC<YearsExperienceInputsProps> = ({
  form,
}) => {
  const {
    setValue,
    watch,
    formState: { errors },
  } = form;

  const stockExperience = watch("investment_experience_with_stocks");
  const stockError = errors.investment_experience_with_stocks?.message;

  const optionsExperience = watch("investment_experience_with_options");
  const optionsError = errors.investment_experience_with_options?.message;

  const onSelect =
    (
      key:
        | "investment_experience_with_stocks"
        | "investment_experience_with_options",
    ) =>
    (value: string) =>
      setValue(key, value as (typeof INVESTMENT_EXPERIENCE_VALUES)[number]);

  return (
    <>
      <RadiosInput
        id="investment_experience_with_stocks"
        label="How many years of experience do you have with stocks?"
        value={stockExperience}
        options={INVESTMENT_EXPERIENCE_OPTIONS}
        onSelect={onSelect("investment_experience_with_stocks")}
        errorMessage={stockError}
      />
      <RadiosInput
        id="investment_experience_with_options"
        label="How many years of experience do you have with options?"
        value={optionsExperience}
        options={INVESTMENT_EXPERIENCE_OPTIONS}
        onSelect={onSelect("investment_experience_with_options")}
        errorMessage={optionsError}
      />
    </>
  );
};
